import { render, staticRenderFns } from "./number-widget.vue?vue&type=template&id=3fd04d02&scoped=true&"
import script from "./number-widget.vue?vue&type=script&lang=js&"
export * from "./number-widget.vue?vue&type=script&lang=js&"
import style0 from "./number-widget.vue?vue&type=style&index=0&id=3fd04d02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd04d02",
  null
  
)

export default component.exports